// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_36643c1","container":"_594af90","place":"_53730e8","currentUser":"_abc7c0c"};